import {
  AllowIn,
  ShortcutInput,
} from 'ng-keyboard-shortcuts';

import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ExtendedRoute } from '@ideapa/app-common';

import { KeyboardFacade } from '../+state/keyboard.facade';

@Component({
  standalone: false,
  selector: 'ideapa-keyboard-shortcuts-listener',
  template: `<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>`,
})
export class KeyboardShortcutsListenerComponent
  implements AfterViewInit, OnInit
{
  @Input()
  activeTab!: ExtendedRoute;

  @Input()
  injectHelp = true;

  @Input()
  showHelp = false;


  shortcuts: ShortcutInput[] = [
    // {
    //   key: '?',
    //   label: 'Help',
    //   description: 'Question mark',
    //   command: (e) => console.log('question mark clicked', { e }),
    //   preventDefault: true,
    // },
    // {
    //   key: ['up up down down left right left right b a enter'],
    //   label: 'Sequences',
    //   description: 'Konami code!',
    //   command: (output: ShortcutEventOutput) =>
    //     console.log('Konami code!!!', output),
    // },
    // F1: apertura dettaglio tasti rapidi
    {
      key: ['F2'],
      label: 'Nuovo',
      description:
        'Apre il form in modalità creazione o aggiunge nuove righe di registrazione',
      command: (e) => this.facade.add(this.activeTab.path),
      allowIn: [
        AllowIn.ContentEditable,
        AllowIn.Select,
        AllowIn.Textarea,
        AllowIn.Input,
      ],
      preventDefault: true,
    },
    {
      key: ['F3'],
      label: 'Salva',
      allowIn: [
        AllowIn.ContentEditable,
        AllowIn.Select,
        AllowIn.Textarea,
        AllowIn.Input,
      ],
      description:
        'Utilizzabile quando è presente il pulsante "Salva" o "Registra" sul form',
      command: (e) => this.facade.save(this.activeTab.path),
      preventDefault: true,
    },
    // F4 apri lente dal componente
    {
      key: ['F4'],
      label: 'Apri elenco ricerca',
      allowIn: [
        AllowIn.ContentEditable,
        AllowIn.Select,
        AllowIn.Textarea,
        AllowIn.Input,
      ],
      description:
        'Utilizzabile se posizionati in capi con tasto ricerca (lente)',
      command: (e) => this.facade.openFilters(this.activeTab.path),
      preventDefault: true,
    },
    // {
    //   key: ['F3'],
    //   label: 'Apri pannello filtri',
    //   description: 'Utilizzabile per aprire il pannello filtri sulle liste',
    //   command: (e) => this.facade.openFilters(this.activeTab.path),
    //   preventDefault: true,
    // },
    // {
    //   key: ['F4'],
    //   label: 'Applica Filtri',
    //   allowIn: [
    //     AllowIn.ContentEditable,
    //     AllowIn.Select,
    //     AllowIn.Textarea,
    //     AllowIn.Input,
    //   ],
    //   description: 'Utilizzabile quando il pannello filtri è aperto',
    //   command: (e) => this.facade.applyFilters(this.activeTab.path),
    //   preventDefault: true,
    // },
    {
      key: ['F6'],
      label: 'Rimuovi riga',
      allowIn: [
        AllowIn.ContentEditable,
        AllowIn.Select,
        AllowIn.Textarea,
        AllowIn.Input,
      ],
      description: `Rimuovi righe selezionate o elimina l'entità aperta quando è presente il pulsante "Elimina" sul form.`,
      command: (e) => this.facade.delete(this.activeTab.path),
      preventDefault: true,
    },
    {
      key: ['F7'],
      label: 'Rimuovi Filtri',
      allowIn: [
        AllowIn.ContentEditable,
        AllowIn.Select,
        AllowIn.Textarea,
        AllowIn.Input,
      ],
      description: 'Rimuove tutti i filtri dalle liste',
      command: (e) => this.facade.resetFilters(this.activeTab.path),
      preventDefault: true,
    },
    // {
    //   key: ['F7'],
    //   label: 'Elimina',
    //   allowIn: [
    //     AllowIn.ContentEditable,
    //     AllowIn.Select,
    //     AllowIn.Textarea,
    //     AllowIn.Input,
    //   ],
    //   description:
    //     'Utilizzabile quando è presente il pulsante "Elimina" sul form',
    //   command: (e) => this.facade.delete(this.activeTab.path),
    //   preventDefault: true,
    // },
  ];

  constructor(private facade: KeyboardFacade) {}

  ngOnInit(): void {
    if (!this.activeTab) {
      throw new Error('Mandatory Active Tab');
    }
  }

  ngAfterViewInit() {}
}
